import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MaterialModule } from '@app/material/material.module';
import { ButtonModule } from '@shared/components/button/button.module';
import { ResponsibilitiesListDialogComponent } from './responsibilities-list-dialog.component';
import { InputModule } from '@app/shared/shared.module';



@NgModule({
  imports: [
    CommonModule,
    MaterialModule,
    ButtonModule,
    FormsModule,
    InputModule,
    ReactiveFormsModule
  ],
  declarations: [ResponsibilitiesListDialogComponent],
  exports: [ResponsibilitiesListDialogComponent],
  entryComponents: [ResponsibilitiesListDialogComponent]
})
export class ResponsibilitiesListDialogModule { }
